export function getServicePrice(record, locationId, defaultPrice = record?.optionPrice ?? record?.itemPrice ?? 0) {
  const localPrice = locationId && record?.locationPrices?.[locationId];
  return typeof localPrice === 'number' && Number.isFinite(localPrice) && localPrice >= 0
    ? localPrice : defaultPrice;
}

export function flattenPricedServices(catalogue, locationId) {
  return (catalogue?.hasCategories || []).flatMap(category =>
    (category.hasItems || []).flatMap(item => {
      const options = item.hasOptions?.length ? item.hasOptions : [null];
      return options.map(option => {
        const record = option || item;
        const defaultPrice = option ? option.optionPrice : item.itemPrice;
        return {
          ...item,
          _id: record._id,
          variations: Boolean(option),
          itemName: option ? `[${option.optionName}] ${item.itemName}` : item.itemName,
          categoryName: category.categoryName,
          categoryIcon: category.categoryIcon,
          defaultPrice,
          locationPrices: record.locationPrices || {},
          price: getServicePrice(record, locationId, defaultPrice),
        };
      });
    }));
}

/** Apply only the field acknowledged by the server, retaining concurrent edits to other prices. */
export function applyCataloguePrice(catalogue, change) {
  const update = record => {
    if (record._id !== change.id) return record;
    if (!change.locationId) return {...record, [change.option ? 'optionPrice' : 'itemPrice']: change.price};
    const locationPrices = {...record.locationPrices};
    if (change.price === null) delete locationPrices[change.locationId];
    else locationPrices[change.locationId] = change.price;
    return {...record, locationPrices};
  };
  return {...catalogue, hasCategories: (catalogue?.hasCategories || []).map(category => ({
    ...category,
    hasItems: (category.hasItems || []).map(item => change.option
      ? {...item, hasOptions: item.hasOptions?.map(update)} : update(item)),
  }))};
}

export function repriceCartForLocation(lines, services) {
  const prices = new Map(services.map(service => [service._id, service.price]));
  return lines.map(line => prices.has(line._id)
    ? {...line, price: prices.get(line._id), voucherCode: prices.get(line._id) === line.price ? line.voucherCode : null}
    : line);
}
